import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Modal, notification } from "antd";
import api from "../../services/api";
import { useEffect } from "react";

export default function ModalVisualizaSenha({ exibirModal, fecharModal, dadosSenha, formulario, aoSalvar }) {

    useEffect(() => {
        if (exibirModal && dadosSenha?.eqp_senhapin) {

            formulario.setFieldsValue({ eqp_senhapin: dadosSenha.eqp_senhapin });
        }
    }, [exibirModal, dadosSenha, formulario]);

    function alterarSenha() {

        let valores = formulario.getFieldValue();

        let dadosAtualizados = {
            eqp_id: dadosSenha.eqp_id,
            eqp_senhapin: valores.eqp_senhapin,
            eqp_senhatouch: valores.eqp_senhatouch
        };
        api.put(`EquipamentoCliente/EditarSenha`, dadosAtualizados)
            .then(() => {
                notification.success({ message: 'Concluído!', description: "Senha alterada com sucesso!" })
                aoSalvar();
            })
            .catch(error => {
                console.log(error);
            }).finally(() => {
                fecharModal();
            })
    }


    return (
        <Modal centered
            title="Senha do Equipamento"
            open={exibirModal}
            destroyOnClose
            onCancel={fecharModal}
            width={500}
            footer={[
                <Button icon={<CloseOutlined />} size="middle" onClick={fecharModal}>
                    Cancelar
                </Button>,
                <Button type="primary" size="middle" icon={<CheckOutlined />} onClick={alterarSenha}>
                    Alterar
                </Button>,
            ]}>
            <div >
                <Form form={formulario} >
                    <Col span={24}>
                        <Form.Item label="Senha do Aparelho" name="eqp_senhapin">
                            <Input
                                placeholder="Digite a senha do aparelho" />
                        </Form.Item>
                    </Col>
                </Form>
            </div>
        </Modal>
    );
}